import { ISubclientRegisterParams, ISubclientUpdateParams, ISuperficialClient } from "interfaces/SubClient";
import {
  activeSubClients,
  createSubClient,
  deleteSubClients,
  updateSubClientService,
} from "../SubClientServices";

interface IDeleteSubClientRegisterProps {
  subClient?: ISuperficialClient;
}

export function handleSubClientActiveSubmit({
  subClient,
}: IDeleteSubClientRegisterProps) {
  if (subClient) {
    activeSubClients(subClient.id)
      .then((res) => {
        if (res.status === true) {
          localStorage.setItem("message", "Sub-cliente ativado com sucesso.");
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err.response);
      });
  } else {
    console.log("no superficial client is selected");
  }
}

export function handleSubClientDeleteSubmit({
  subClient,
}: IDeleteSubClientRegisterProps) {
  if (subClient) {
    deleteSubClients(subClient.id)
      .then((res) => {
        if (res.status === true) {
          localStorage.setItem(
            "message",
            "Sub-cliente desativado com sucesso."
          );
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err.response);
      });
  } else {
    console.log("no superficial client is selected");
  }
}

export async function handleSubClientRegisterSubmit(registerObject: ISubclientRegisterParams) {
  return await createSubClient(registerObject)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}

export async function handleSubClientUpdateSubmit(updateSubclientParams: ISubclientUpdateParams) {
  return await updateSubClientService(updateSubclientParams)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err.response;
    });
}
